export default function Welcome() {
	return (
		<div style={{ height: "70vh", display: "flex", justifyContent: "center", alignItems: "center", color:"var(--text-color)" }}>
			<h1>Welcome to LynkID</h1>
		</div>
	);
}
